import React, { useEffect, useState } from "react";
import Header from "../../components/Header/Header";
import "./Leaderboard.css";

import { getLeaderBoard } from "../../api/leaderboardApi";

const button = ["Daily", "Weekly", "Monthly"];
const filter = ["Infinite", "Time"];

const column = [
  "S.No",
  "Player Name",
  "Rank",
  "Total Kills",
  "Total Score",
  "Total Matches",
];

export default function Leaderboard() {
  const [selectedType, setSelectedType] = useState("Daily");
  const [selectedMode, setSelectedMode] = useState("Infinite");

  const [leaderBoardData, setLeaderBoardData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchLeaderBoadrData = async () => {
    try {
      setLoading(true);
      const type = selectedType.toLowerCase();
      const mode = selectedMode.toLowerCase();

      const res = await getLeaderBoard(type, mode);
      setLeaderBoardData(res?.data || []);
      console.log("leaderboard resp:", res);
    } catch (error) {
      console.error("error on get leaderboard data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeaderBoadrData();
  }, [selectedType, selectedMode]);

  return (
    <div className="main">
      {/* <Header /> */}
      <div className="contact-header">
        <h3>Leader Board</h3>
        <p>View lates Leaders</p>
      </div>

      <div className="filter">
        <div className="filter-group">
          {button.map((item) => (
            <button
              key={item}
              className={`filter-btn ${selectedType === item ? "active" : ""}`}
              onClick={() => setSelectedType(item)}
            >
              {item}
            </button>
          ))}
        </div>

        <div className="filter-group">
          {filter.map((item) => (
            <button
              key={item}
              className={`filter-btn ${selectedMode === item ? "active" : ""}`}
              onClick={() => setSelectedMode(item)}
            >
              {item}
            </button>
          ))}
        </div>
      </div>

      <div className="table-wrapper">
        <table className="leaderboard-table">
          <thead>
            <tr className="table-col">
              {column.map((col) => (
                <th key={col}>{col}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {loading && leaderBoardData.length === 0 ? (
              <tr>
                <td colSpan={column.length} style={{ textAlign: "center" }}>
                  Loading...
                </td>
              </tr>
            ) : !loading && leaderBoardData.length === 0 ? (
              <tr>
                <td colSpan={7} style={{ textAlign: "center" }}>
                  No Data Found
                </td>
              </tr>
            ) : (
              leaderBoardData?.map((item, index) => (
                <tr key={item._id}>
                  <td>{index + 1}</td>
                  <td>{item.name}</td>
                  <td>{item.rank}</td>
                  <td>{item.totalKills}</td>
                  <td>{item.totalScore}</td>
                  <td>{item.totalMatches}</td>
                  {/* <td>{item._id}</td> */}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
